export default __webpack_public_path__ + "media/wallpaper/five_thumbnail_large-6a3aa07d.jpg";